
import {
  SystemRequestGet as $_get,
  SystemRequestPost as $_post
} from '@/request/http.js'


/**
 * 源数据
 */
let state = () => ({
  // 难度数据列表
  diffList: []
});

/**
 * 同步
 */
const mutations = {
  /**
   * 更新 难度数据
   */
  updataDiffList(state, list) {
    state.diffList = list;
  }
};


/**
 * 异步
 */
const actions = {
  /**
   * 获取难度数据
   * @param {string|number} kemu_id	// 科目ID 必须	1
   * @param {string} jie_id	// 章节ID集合(知识点ID)	必须	102,103,104
   * @param {string} year	// 年份集合				必须	2018,2019(不限传空字符串)
   */
  getDiffList({
    commit
  }, {
    kemu_id,
    jie_id,
    year
  }) {
    $_get('test_getHard', {
      kemu_id,
      jie_id,
      year
    })
      .then(res => {
        commit('updataDiffList', res.data.tixing_list)
      });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/test.js